<tlc-churn-flow-step-template [currentStep]="1">
  <div class="left">
    <div layout-vertical>
      <rt-heading variant="large-xx dark bold"
        >{{ 'tlc.churn_flow.steps.intro.heading' | translate }}
      </rt-heading>
      <span margin-top-small-xx>{{ 'tlc.churn_flow.steps.intro.subheading' | translate }}</span>
    </div>
    @if (cancellationDatesSignal()) {
      <rt-infobox
        type="information"
        iconName="info-outline"
        [isDismissible]="false"
        margin-top-large
      >
        <span [innerHTML]="infoboxText()"></span>
      </rt-infobox>
    }
    <div class="options-container">
      @for (option of churnOptions; track $index) {
        <ng-container
          [ngTemplateOutlet]="churnOption"
          [ngTemplateOutletContext]="{ option: option }"
        />
      }
    </div>
    <div class="button-container">
      <rt-button variant="plain" (click)="stayWithTellent()">
        {{ 'tlc.churn_flow.common.stay_with_tellent' | translate }}
      </rt-button>
    </div>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>

<ng-template #churnOption let-option="option">
  <div class="option">
    <tlc-churn-flow-solution-icon class="icon" [variant]="option.iconVariant" />
    <rt-heading class="heading">{{ option.heading }}</rt-heading>
    <span class="subheading">{{ option.subheading }}</span>
    <rt-button class="cta" [variant]="option.buttonVariant" (click)="option.action()"
      >{{ option.buttonText }}
    </rt-button>
  </div>
</ng-template>
